import { render, staticRenderFns } from "./CircuitoNotasPage.vue?vue&type=template&id=bc0b10b8"
import script from "./CircuitoNotasPage.vue?vue&type=script&lang=js"
export * from "./CircuitoNotasPage.vue?vue&type=script&lang=js"
import style0 from "./CircuitoNotasPage.vue?vue&type=style&index=0&id=bc0b10b8&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports